// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3Uams","row":"ProcedureTreatmentSummary_row__J8e9t"};